import { render } from "./AppWrapper.vue?vue&type=template&id=46e0d21f"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__